import api from "./api";

// Capa de servicios de la API Pública (0359 F4): API Key de cuenta.
// Autenticadas con JWT del panel (para que el admin obtenga/regenere su token de cuenta).
export const getAccountApiKey = () => api.get("/api/v1/account/api-key");
export const regenerateAccountApiKey = () =>
  api.post("/api/v1/account/api-key/regenerate");
